<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "Credits"
    }
</script>

<style scoped>

</style>